const shadows = {
  small: `
    shadow-color: #000;
    shadow-offset: 0px 1px;
    shadow-opacity: 0.1;
    elevation: 2;
  `,
}

export default shadows
